import React, { Component } from 'react';
import { Nav, NavDropdown, Navbar, Button, Dropdown } from 'react-bootstrap';
import { isMobile } from 'react-device-detect'
//import Auth from '../middleware/auth';
//import {Alert} from 'react-bootstrap';
//import {Toast} from 'react-bootstrap';

class menu_usuario extends Component {
  constructor(props) {
    const tipo = sessionStorage.getItem('tipo');
    const empresa = sessionStorage.getItem('company');
    const nombre_empresa = sessionStorage.getItem('nombre');
    const nombre_usuario = sessionStorage.getItem('usuario');
    const fact = sessionStorage.getItem('fact');
    const cat = sessionStorage.getItem('cat');
    const est = sessionStorage.getItem('est');
    const ven = sessionStorage.getItem('ven');
    const ped = sessionStorage.getItem('ped');
    const inv = sessionStorage.getItem('inv');
    const arc = sessionStorage.getItem('arc');
    const pos = sessionStorage.getItem('pos');
    const aped = sessionStorage.getItem('aped');
    const apro = sessionStorage.getItem('aprobacion');
    const menu = (sessionStorage.getItem('menu') || "1");
    super(props);
    this.state = {
      msg: 0,
      currrentType: tipo,
      currentCompany: empresa,
      currentCompanyName: nombre_empresa,
      currentUserName: nombre_usuario,
      fact,
      cat,
      est,
      ven,
      ped,
      inv,
      arc,
      pos,
      menu,
      aped,
      apro
    }
  }

  showMenu = () => {
    sessionStorage.setItem('menu', "1");
    this.setState({
      menu: "1"
    })
  }
  showVentas = () => {
    sessionStorage.setItem('menu', "0");
    this.setState({
      menu: "0"
    })
  }
  showNomina = () => {
    sessionStorage.setItem('menu', '2');
    this.setState({
      menu: "2"
    })
  }

  render() {
    //const validarTipo = (this.state.currrentType === '0' || this.state.currrentType === '1')
    const rutaEmpresa = (this.state.currrentType === '0') ? '/empresa' : '/empresa/crear/?' + this.state.currentCompany;
    const { fact } = this.state;
    const { cat } = this.state;
    const { est } = this.state;
    const { ven } = this.state;
    const { inv } = this.state;
    const { pos } = this.state;
    const { arc } = this.state;
    const { ped } = this.state;
    const { aped } = this.state;
    const { apro } = this.state;
    const { currentCompany } = this.state;
    return (
      <div style={{ 'fontSize': 12 }}>
        <Navbar collapseOnSelect expand="lg" bg="light" variant="light">
          <Navbar.Brand href="/home"><img src="/logopage.png" alt="IngenIA 365" height="40px" width="150px"></img></Navbar.Brand>
          <Navbar.Toggle aria-controls="responsive-navbar-nav" />
          <Navbar.Collapse id="responsive-navbar-nav">
            {this.state.menu === "1" && <Nav className="mr-auto" >
              <Nav className="mr-auto">
                {est &&
                  <NavDropdown title="Estructuracion" id="collasible-nav-dropdown">
                    <NavDropdown title="Empresa" id="collasible-nav-dropdown">
                      <NavDropdown.Item href={rutaEmpresa}>Empresa</NavDropdown.Item>
                      <NavDropdown.Item href="/parametros">Parametros</NavDropdown.Item>
                    </NavDropdown>
                    <NavDropdown.Item href="/usuarios">Usuarios</NavDropdown.Item>
                    <NavDropdown.Item href="/email">Correo</NavDropdown.Item>
                    <NavDropdown.Item href="/resoluciones">Resoluciones</NavDropdown.Item>
                  </NavDropdown>
                }
                {cat &&
                  <NavDropdown title="Catalogo" id="collasible-nav-dropdown">
                    <NavDropdown.Item href="/formapago">Formas Pago</NavDropdown.Item>
                    <NavDropdown.Item href="/metodos">Metodos Pago</NavDropdown.Item>
                    <Dropdown.Divider />
                    <NavDropdown.Item href="/tipoinventario">Tipos de Inventario</NavDropdown.Item>
                    <NavDropdown.Item href="/grupoinventario">Grupos de inventario</NavDropdown.Item>
                    <NavDropdown.Item href="/lineasinventario">Lineas de inventario</NavDropdown.Item>
                    {/* <NavDropdown.Item href="/categorias">Lineas de inventario</NavDropdown.Item> */}
                    <Dropdown.Divider />

                    <NavDropdown.Item href="/listaprecio">Listas Precios</NavDropdown.Item>
                    <NavDropdown.Item href="/descuentos">Listas Descuentos</NavDropdown.Item>
                    <Dropdown.Divider />
                    <NavDropdown.Item href="/retenciones">Retenciones</NavDropdown.Item>
                    <NavDropdown.Item href="/impuestos">Impuestos</NavDropdown.Item>
                    <Dropdown.Divider />
                    <NavDropdown.Item href="/servicios">Servicios/Items</NavDropdown.Item>
                    <NavDropdown.Item href="/barras">Codigos de barra</NavDropdown.Item>
                    <NavDropdown.Item href="/unidades">Unidades de medida</NavDropdown.Item>
                    <NavDropdown.Item href="/vendedores">Vendedores</NavDropdown.Item>
                    <NavDropdown.Item href="/clientes">Clientes</NavDropdown.Item>
                    <NavDropdown title="Carga Catalogos" id="nav-dropdown" className="ml-3">
                      <NavDropdown.Item href="/cargaclientes" eventKey="t1">Carga Clientes</NavDropdown.Item>
                      <NavDropdown.Item href="/cargaitems" eventKey="t1">Carga Items</NavDropdown.Item>
                      <NavDropdown.Item href="/cargaprecios" eventKey="t1">Carga Precios</NavDropdown.Item>
                    </NavDropdown>
                  </NavDropdown>
                }
                {(ven || pos || ped) &&
                  <Nav.Link onClick={this.showVentas}>Ventas</Nav.Link>
                }
                <Nav.Link onClick={this.showNomina}>Nomina</Nav.Link>
                {fact &&
                  <NavDropdown title="Facturacion Electronica" id="collasible-nav-dropdown">
                    <NavDropdown.Item href="/gestion">Gestion</NavDropdown.Item>
                    <NavDropdown.Item href="/prefacturas">Pre-factura</NavDropdown.Item>
                    <NavDropdown.Item href="/clientes">Clientes</NavDropdown.Item>
                    <NavDropdown.Item href="/acuse">Acuse Recibido</NavDropdown.Item>
                    <NavDropdown.Item href="/reporteempresas">Reporte Estado</NavDropdown.Item>
                    <NavDropdown.Item href="/reportedetalladofe">Reporte Detallado</NavDropdown.Item>
                    <NavDropdown.Item href="/saltoreporte">Reporte Saltos</NavDropdown.Item>
                  </NavDropdown>
                }
                {inv &&
                  <NavDropdown title="Inventario" id="collasible-nav-dropdown">
                    <NavDropdown.Item href="/bodegas">Administrar Bodegas</NavDropdown.Item>
                    <NavDropdown.Item href="/ingresoinventario">Ingreso de Inventario</NavDropdown.Item>
                    <NavDropdown.Item href="/ajusteinventario">Ajustes Inventario</NavDropdown.Item>
                    <NavDropdown.Item href="/transladoinventario">Traslados</NavDropdown.Item>
                    <NavDropdown title="Reportes" id="nav-dropdown" className="ml-3">
                      <NavDropdown.Item href="/reporte/existencia" eventKey="t1">Reporte de Existencia</NavDropdown.Item>
                      <NavDropdown.Item href="/reporte/movimiento" eventKey="t3">Reporte de movimiento</NavDropdown.Item>
                    </NavDropdown>
                  </NavDropdown>
                }
                {arc && <NavDropdown title="Archivos" id="collasible-nav-dropdown">
                  <NavDropdown.Item href="/cargaterceros">Terceros</NavDropdown.Item>
                </NavDropdown>
                }
                {currentCompany === "111111111" && <NavDropdown title="MENU FACTURAR365" id="collasible-nav-dropdown">
                  <NavDropdown.Item href="/reporteempresas">Reporte Estado Facturacion</NavDropdown.Item>
                  <NavDropdown.Item href="/reportenomina">Reporte Estado Nomina</NavDropdown.Item>
                  <NavDropdown.Item href="/companyblock">Inactivar Empresas</NavDropdown.Item> 
                  <NavDropdown.Item href="/reporteconsumo">Reporte Consumo</NavDropdown.Item> 
                </NavDropdown>
                }
              </Nav>
            </Nav>
            }
            {this.state.menu === "0" &&
              <Nav className="mr-auto" >
                <Navbar bg="light" expand="lg">
                  <Nav className="mr-auto">
                    {ven && <Nav.Link href="/facturas">Facturas</Nav.Link>}
                    {ven && <Nav.Link href="/notasc">Notas Créditos</Nav.Link>}
                    {ven && <Nav.Link href="/notasd">Notas Débitos</Nav.Link>}
                    {ven && <Nav.Link href="/documentosoporte">Documento Soporte</Nav.Link>}
                    {ped && <NavDropdown title="Pedidos" id="collasible-nav-dropdown" className="ml-3">
                      {(isMobile) &&
                        <NavDropdown.Item href="/pedidosmovil">Crear Pedido</NavDropdown.Item>
                      }
                      {(!isMobile) &&
                        <NavDropdown.Item href="/pedidos">Crear Pedido</NavDropdown.Item>
                      }
                    </NavDropdown>}
                    {aped && <NavDropdown title="Admin Pedidos" id="collasible-nav-dropdown" className="ml-3">
                      <NavDropdown.Item href="/generarplanopedidos">Generar Plano</NavDropdown.Item>
                      <NavDropdown.Item href="/convertidorpedfac">Facturar Pedidos</NavDropdown.Item>
                      <NavDropdown.Item href="/aprobarpedidos" disabled={!(apro && apro==="1")}>Aprobar Pedidos</NavDropdown.Item>
                      <NavDropdown.Item href="/reportepedidos">Reporte Pedidos</NavDropdown.Item>
                    </NavDropdown>}
                    {pos && <NavDropdown title="POS" id="collasible-nav-dropdown">
                      <NavDropdown.Item href="/factpost">Facturas POS</NavDropdown.Item>
                      <NavDropdown.Item href="/impresionpos">Re-impresion POS</NavDropdown.Item>
                      <NavDropdown.Item href="/turnos">Turnos</NavDropdown.Item>
                      <NavDropdown title="Reportes" id="nav-dropdown" className="ml-3">
                        <NavDropdown.Item href="/reporte/ventas" eventKey="t1">Reportes de ventas por items</NavDropdown.Item>
                        <NavDropdown.Item href="/reporte/documentos" eventKey="t1">Reportes de ventas por documento</NavDropdown.Item>
                      </NavDropdown>
                    </NavDropdown>}
                    {ven && <NavDropdown title="Cartera" id="collasible-nav-dropdown">
                      <NavDropdown.Item href="/reciboscaja">Recibos de caja</NavDropdown.Item>
                      <NavDropdown.Item href="/reportecartera">Reporte de cartera</NavDropdown.Item>
                      <NavDropdown.Item href="/reporterecibos">Reporte de Recibos</NavDropdown.Item>
                    </NavDropdown>}

                    <Nav.Link onClick={this.showMenu}>Menú</Nav.Link>
                  </Nav>
                </Navbar>
                {/* <Nav.Link href="/reportes">Reportes</Nav.Link> */}
              </Nav>
            }
            {this.state.menu === "2" &&
              <Nav className="mr-auto">

                <NavDropdown title="Catalogo" id="collasible-nav-dropdown">
                  <NavDropdown.Item href="/empleados">Empleados</NavDropdown.Item>
                  <NavDropdown.Item href="/homologacion">Homologacion</NavDropdown.Item>
                </NavDropdown>

                <NavDropdown title="Nomina" id="collasible-nav-dropdown">
                  <NavDropdown.Item href="/pagonomina">Generar documento</NavDropdown.Item>
                  <NavDropdown.Item href="/gestionNomina">Gestionar documento</NavDropdown.Item>
                  <NavDropdown.Item href="/reportenomina">Reporte Estado</NavDropdown.Item>
                  <NavDropdown.Item href="/reportedetalladonomina">Reporte Detallado</NavDropdown.Item>
                  <NavDropdown.Item href="/reportenominaemp">Reporte Consolidados Empleados</NavDropdown.Item>
                  <NavDropdown.Item href="/gestionnominaemp">Reporte Empleados</NavDropdown.Item>
                </NavDropdown>

                <Nav.Link onClick={this.showMenu}>Menú</Nav.Link>
              </Nav>
            }

            <Nav>

              <Navbar.Brand><h6>{this.state.currentUserName}</h6></Navbar.Brand>
              <Navbar.Brand><h6>{this.state.currentCompanyName}</h6></Navbar.Brand>

              <Button href="/cerrarsesion" variant="outline-secondary">Cerrar Sesion</Button>
            </Nav>
          </Navbar.Collapse>
        </Navbar>
      </div>);
  }
}
export default (menu_usuario);